import { ChangeDetectorRef, Component } from '@angular/core';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { LoadingConst } from 'src/app/core/constants/color-loading';
import { SecureStorageService } from 'src/app/core/validators/secure-storage.service';

const PrimaryColor = LoadingConst.colorPrimary;
const SecondaryColor = LoadingConst.colorSecondary;

@Component({
  selector: 'app-loading',
  standalone: false,
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent {
  isVisible = false;
  public primaryColour = PrimaryColor;
  public secondaryColour = SecondaryColor;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  constructor(
    private loadinService: LoadingService,
    private secureStorageService: SecureStorageService,
    private cdRef: ChangeDetectorRef
    
  ) { }

  ngOnInit(): void {
    this.loadinService.isVisible$.subscribe(isVisible => {
      this.isVisible = isVisible;
      this.cdRef.detectChanges();
    });

    const datos = JSON.parse(this.secureStorageService.getData('designConfig') || "[]")
    this.primaryColour = datos?.COLOR_TEMA_PRIMARIO ? datos?.COLOR_TEMA_PRIMARIO : PrimaryColor;
    this.secondaryColour = datos?.COLOR_TEMA_SECUNDARIO ? datos?.COLOR_TEMA_SECUNDARIO : SecondaryColor;
  }
}
